export default {"src":"/_next/static/media/search.f8af9e8b.gif","height":35,"width":35};